module.exports = __webpack_public_path__ + "./img/upload.426334e5350015e2e4eae5b6c06b75ff.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/upload.png
// module id = ./assets/images/upload.png
// module chunks = 0